import { CEViewBase } from './ce-view-base'


export class CEView extends CEViewBase {

}